<div class="modal-header" style="background-color:#fff;">
    <div class="container-fluid">
        <div class="row" style="height: 250px; border: 1px solid black;">
            <!-- Imagen lateral -->
            <div class="col h-100">
                <img src="{{eventImage}}" class="img-fluid h-100">
            </div>
        </div>
        <div class="row" style="height: 250px; border: 1px solid black;">
            <!-- Contenedor de esquema -->
            <div class="col h-100" style="overflow-x: auto; overflow-y: hidden;">
                <canvas id="myCanvas" #myCanvas style="width: 1800px; height: 100%;"></canvas>
            </div>
        </div>
    </div>
</div>

<div class="modal-body" style="background-color:#fff; box-shadow: 0px 7px 5px silver;">
    <div class="container-fluid">
        <form #typForm="ngForm">
            <div class="form-row">
                <div class="form-group col-md-3">
                    <label for="vehSelector">{{ 'typification.vehicles' | translate }}</label>
                    <select (change)="vehicleSelected($event.target.value)" class="custom-select" id="vehSelector">
                        <ng-container *ngFor="let vehicles of vehicleBunde">
                            <ng-container *ngIf="vehicles.order === '2' && vehicles.type !== 'cabin'">
                                <option selected>{{vehicles.order - 1}}</option>
                            </ng-container>
                            <ng-container
                                *ngIf="vehicles.order !== '2' && vehicles.order !== '1' && vehicles.type !== 'cabin'">
                                <option>{{vehicles.order - 1}}</option>
                            </ng-container>
                        </ng-container>
                    </select>
                </div>

                <div class="form-group col-md-3">
                    <label for="plate">{{ 'typification.plate' | translate }}</label>
                    <ng-container *ngIf="systemTypConfig.editPlate === 'true'">
                        <input type="text" class="form-control" id="plate" [(ngModel)]="plate" name="plate">
                    </ng-container>
                    <ng-container *ngIf="systemTypConfig.editPlate === 'false'">
                        <input type="text" class="form-control" id="plate" [(ngModel)]="plate" name="plate" disabled>
                    </ng-container>
                </div>

                <div class="form-group col-md-3">
                    <label for="bundleSelector">{{ 'typification.bundle' | translate }}</label>
                    <select (change)="bundleSelected($event.target.value);" class="custom-select" id="bundleSelector">
                        <ng-container *ngFor="let bundle of vehicleBunde[vehicleIndex].elements.element">
                            <ng-container *ngIf="bundle.id === '1'">
                                <option selected>{{bundle.id}}</option>
                            </ng-container>
                            <ng-container *ngIf="bundle.id !== '1'">
                                <option>{{bundle.id}}</option>
                            </ng-container>
                        </ng-container>
                    </select>
                </div>

                <div class="form-group col-md-3">
                    <label for="bundleArrangementSelector">{{ 'typification.bundle-distribution' | translate }}</label>
                    <select class="custom-select" id="bundleArrangementSelector"
                        (change)="bundleArrangementSelected($event)">
                        <ng-container *ngFor="let arrangement of systemTypConfig.arrangements">
                            <ng-container
                                *ngFor="let param of vehicleBunde[vehicleIndex].elements.element[bundleIndex].params.param">
                                <ng-container *ngIf="param.name === 'arrange'">
                                    <option [value]="arrangement.value" [selected]="param.value === arrangement.value">
                                        {{arrangement.value}}
                                    </option>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-3">
                    <label>{{ 'typification.total-vehicles' | translate }} {{vehicleBunde.length - 1}}</label>
                </div>
                <div class="form-group col-md-3">
                    <label>{{ 'typification.total-bundles' | translate }}
                        {{vehicleBunde[vehicleIndex].elements.element.length}}</label>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-3">
                    <ng-container
                        *ngIf="!systemTypConfig.maxVehicle || (vehicleBunde.length - 1) < systemTypConfig.maxVehicle">
                        <button id="btn_add_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newVehicle();">{{ 'typification.add-vehicle' | translate }}</button>
                    </ng-container>
                    <ng-container *ngIf="(vehicleBunde.length - 1) == systemTypConfig.maxVehicle">
                        <button id="btn_add_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newVehicle();" disabled>{{ 'typification.add-vehicle' | translate }}</button>
                    </ng-container>
                </div>
                <div class="form-group col-md-3">
                    <ng-container *ngIf="vehicleBunde[vehicleIndex].order === '2'">
                        <button id="btn_remove_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            ngbTooltip="{{ 'typification.first-vehicle-remove' | translate }}" disabled>{{
                            'typification.remove-vehicle' | translate }}</button>
                    </ng-container>
                    <ng-container
                        *ngIf="vehicleBunde[vehicleIndex].order !== '2' && vehicleBunde[vehicleIndex].order !== '1'">
                        <button id="btn_remove_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="deleteVehicle();">{{ 'typification.remove-vehicle' | translate }}</button>
                    </ng-container>
                </div>
                <div class="form-group col-md-3">
                    <ng-container
                        *ngIf="!systemTypConfig.maxBundle || vehicleBunde[vehicleIndex].elements.element.length < systemTypConfig.maxBundle">
                        <button id="btn_add_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newBundle();">{{ 'typification.add-bundle' | translate }}</button>
                    </ng-container>
                    <ng-container
                        *ngIf="vehicleBunde[vehicleIndex].elements.element.length == systemTypConfig.maxBundle">
                        <button id="btn_add_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newBundle();" disabled>{{ 'typification.add-bundle' | translate }}</button>
                    </ng-container>
                </div>
                <div class="form-group col-md-3">
                    <ng-container *ngIf="vehicleBunde[vehicleIndex].elements.element[bundleIndex].id === '1'">
                        <button id="btn_remove_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            ngbTooltip="{{ 'typification.first-bundle-remove' | translate }}" disabled>{{
                            'typification.remove-bundle' | translate }}</button>
                    </ng-container>
                    <ng-container *ngIf="vehicleBunde[vehicleIndex].elements.element[bundleIndex].id !== '1'">
                        <button id="btn_remove_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="deleteBundle();">{{ 'typification.remove-bundle' | translate }}</button>
                    </ng-container>
                </div>
            </div>
        </form>
    </div>
</div>

<div class="modal-footer" style="background-color:#fff; box-shadow: 0px 7px 5px silver;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-4 text-left">
                <button id="btn_exit" type="button" class="btn sharp btn-outline-secondary btn-lg"
                    (click)="activeModal.dismiss('exits click')">{{ 'typification.exit' | translate }}</button>
            </div>
            <div class="col-8 text-right">
                <button id="btn_undo" type="button" class="btn sharp btn-outline-secondary btn-lg"
                    (click)="resetTyp();">{{ 'typification.undo' | translate }}</button>
                &nbsp;
                <button type="btn_save" class="btn sharp btn-outline-secondary btn-lg" (click)="saveTyp();">{{
                    'typification.next' | translate }}</button>
            </div>
        </div>
    </div>
</div>